module.exports = __webpack_public_path__ + "static/media/YB5M03_6.f80992f6.jpg";